import * as React from 'react';
import { Viewport } from 'lib/viewport';
import { Floorplan } from 'lib/floorplan';

type Props = {
  image: HTMLImageElement;
  opacity?: number;
  viewport: Viewport;
  floorplan: Floorplan;
};

const FloorplanImageView: React.FunctionComponent<Props> = ({
  image,
  opacity,
  floorplan,
  viewport,
}) => {
  const { width, height } = viewport;

  const scale = (image.width / floorplan.width) * viewport.zoom;

  return (
    <div
      style={{
        position: 'absolute',
        width,
        height,
        opacity,
        left: 0,
        top: 0,
        filter: 'grayscale(1)', // Ensure all floorplan images are shown in grayscale
      }}
    >
      <img
        src={image.src}
        alt=""
        style={{
          transformOrigin: 'left top',
          transform: `
            translate(
              ${-1 * viewport.left * viewport.zoom}px,
              ${-1 * viewport.top * viewport.zoom}px
            )
            rotate(${floorplan.rotation}deg)
            scale(${scale}, ${scale})
          `,
        }}
      />
    </div>
  );
};

export default React.memo(FloorplanImageView);
